import { jsx as _jsx } from "react/jsx-runtime";
import { getButtonClasses } from '#pplx/frontend/aether/components/Button/classes.js';
import { Tooltip } from '#pplx/frontend/aether/components/Tooltip/index.js';
import { ButtonPrimitive } from '#pplx/frontend/aether/primitives/ButtonPrimitive/index.js';
import { SourcesMenuButtonContent } from '#pplx/frontend/apps/ask/ask-input/ask-input-sources-menu/components/SourcesMenuButtonContent.js';
import React from 'react';
import { useIntl } from 'react-intl';
export const SourcesMenuButton = React.memo(function SourcesMenuButton({ sources, tooltip, size = 'default', disabled = false, 
// We intentionally capture the rest of props that could be cloned/passed in by 3rd-party libraries
// such as Radix UI for their own internal usage such as data-state, onFocus, onBlur, etc.
...props }) {
    const { $t } = useIntl();
    const classes = getButtonClasses({
        variant: 'text',
        disabled,
        size,
        // Ensures spacing is correct for 1 source (icon button) vs. multiple sources (icon stack)
        iconOnly: sources.length === 1,
    });
    const button = (_jsx(ButtonPrimitive, { "aria-label": $t({
            defaultMessage: 'Sources',
            description: 'Aria label for the sources menu button',
            id: '3cb0f97010',
        }), className: classes, disabled: disabled, ...props, children: _jsx(SourcesMenuButtonContent, { sources: sources, size: size }) }));
    if (tooltip) {
        return _jsx(Tooltip, { content: tooltip, children: button });
    }
    return button;
});
//# sourceMappingURL=SourcesMenuButton.js.map